/*
  Web Component: rewards-tier-scroller
  Automatically scrolls horizontally to the active tier on mobile.
*/

class RewardsTierScroller extends HTMLElement {
  connectedCallback() {
    if (typeof window === 'undefined') return;
    if (window.innerWidth > 768) return;

    // Defer until layout is ready
    requestAnimationFrame(() => this.scrollToActiveTier());
  }

  scrollToActiveTier() {
    const tableWrapper = this.querySelector('#tier-tablet-wrapper'); // The custom element acts as the scroll container
    const currentTier = this.querySelector('th.tw-bg-account-gold');
    const firstColumn = this.querySelector('th:first-child');

    if (!tableWrapper || !currentTier || !firstColumn) return;

    const tierRect = currentTier.getBoundingClientRect();
    const firstColRect = firstColumn.getBoundingClientRect();

    const scrollAmount = tierRect.left - firstColRect.right;
    tableWrapper.scrollLeft += scrollAmount;
  }
}

if (!customElements.get('rewards-tier-scroller')) {
  customElements.define('rewards-tier-scroller', RewardsTierScroller);
}
